import {userApi} from "./user-api";
import {setIsDeletedProfile, setIsPasswordReseted, setProfile, setUser} from "./user-actions";
import {logout, setRecoveryToken, setToken} from "../auth/auth-actions";
import {getExperience} from "../logbook/logbook-thunks";


export const getUser = () => async (dispatch) => {
  let response
  try {
    response = await userApi.getCurrentUser()
    if(response?.detail === 'Not authenticated') throw new Error('not authenticated')
    dispatch(setUser(response.data))
  } catch (e) {
    localStorage.removeItem('token')
    dispatch(setToken(false))
  }
  if(response === undefined) return
  try {
    const res = await userApi.getProfile(response.data.id)
    console.log('res.data', res.data)
    if(res.data.image_link) {
      try {
        const resFile = await userApi.getFile(res.data.image_link)
        dispatch(setProfile({...res.data, image_link: Buffer.from(resFile.data, 'binary').toString('base64')}))
      } catch (e) {
        dispatch(setProfile(res.data))
      }
    } else {
      dispatch(setProfile(res.data))
    }
  dispatch(getExperience(res.data.id))
  } catch (e) {
    console.log(e)
    // try {
    //   const res = await userApi.createProfile()
    //   dispatch(setProfile(res.data))
    // } catch (e) {
    //   console.log('error', e)
    // }
  }
}

export const updateProfile = (first_name, last_name, phone_number, birth_date) => async (dispatch, getState) => {
  const {user} = getState().userReducer
  const response = await userApi.updateProfile(user.id, first_name, last_name, phone_number, birth_date)
  if(response.data.image_link) {
    try {
      const resFile = await userApi.getFile(response.data.image_link)
      dispatch(setProfile({...response.data, image_link: Buffer.from(resFile.data, 'binary').toString('base64')}))
    } catch (e) {
      dispatch(setProfile(response.data))
    }
  } else {
    dispatch(setProfile(response.data))
  }
  // dispatch(setProfile(response.data))
}

export const resetPassword = (token, newPassword) => async (dispatch) => {
  try {
    await userApi.resetPassword(token, newPassword)
    dispatch(setRecoveryToken(null))
    dispatch(setIsPasswordReseted(true))
  } catch (e) {
    dispatch(setRecoveryToken(null))
    dispatch(setIsPasswordReseted(null))
  }
}

export const uploadFile = (file) => async (dispatch, getState) => {
  const {profile, user} = getState().userReducer
  try {
    const response = await userApi.uploadFile(file, true)
    await userApi.uploadAvatar(user.id, response.data.id)
    const res = await userApi.getFile(response.data.id)
    dispatch(setProfile({...profile, image_link: Buffer.from(res.data, 'binary').toString('base64')}))
  } catch (e) {
  }
}
export const sendConfirmEmail = () => async (dispatch, getState) => {
  const {profile, user} = getState().userReducer
  const response = await userApi.sendConfirmEmail(profile.id, user.email)
  console.log(response.data)
}

export const deleteProfile = () => async (dispatch, getState) => {
  const {profile} = getState().userReducer
  await userApi.deleteProfile(profile.id)
  localStorage.removeItem('token')
  dispatch(setToken(false))
  dispatch(logout())
  dispatch(setIsDeletedProfile(true))
}
